import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import format from 'date-fns/format';
import * as locale from 'date-fns/esm/locale';

@Pipe({
  name: 'custDateMedium',
})
export class CustDateMediumPipe implements PipeTransform {
  transform(date: any, dateFunctionConfig?: any) {
    if (date != '') {
      return format(new Date(moment(date).toDate()), dateFunctionConfig.dateMediumFormat, { locale: locale[dateFunctionConfig.locale] });
    } else {
      return '';
    }
  }
}

@Pipe({
  name: 'reasonMessagePipe',
})
export class ReasonMessagePipe implements PipeTransform {
  transform(data, rGuestVillaMessages) {
    if (data === 'Transaction time out') {
      return rGuestVillaMessages.confirmation.confirmationTransactionTimeoutMessage
        ? rGuestVillaMessages.confirmation.confirmationTransactionTimeoutMessage
        : data;
    } else {
      return data;
    }
  }
}
